import React, { Suspense } from 'react';
import { Routes, Route, useLocation } from "react-router-dom";

//Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import VerticalLayout from "../Layouts/index";

//routes
import { authProtectedRoutes, publicRoutes } from "./allRoutes";
import { AuthProtected } from './AuthProtected';

// Fallback loader shown while lazy chunks are loading
const PageLoader = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      background: "#f3f3f9",
    }}
  >
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Ачааллаж байна...</span>
    </div>
  </div>
);

const Index = () => {
    const location = useLocation();

    return (
        <React.Fragment>
            <Suspense fallback={<PageLoader />}>
                <Routes>
                    <Route>
                        {publicRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={
                                    <NonAuthLayout>
                                        {route.component}
                                    </NonAuthLayout>
                                }
                                key={idx}
                                exact={true}
                            />
                        ))}
                    </Route>

                    <Route>
                        {authProtectedRoutes.map((route, idx) => (
                            <Route
                                path={route.path}
                                element={
                                    <AuthProtected>
                                        <VerticalLayout>
                                            {React.cloneElement(route.component, { key: location.key })}
                                        </VerticalLayout>
                                    </AuthProtected>}
                                key={idx}
                                exact={true}
                            />
                        ))}
                    </Route>
                </Routes>
            </Suspense>
        </React.Fragment>
    );
};

export default Index;